import { AxiosInstance } from "../axiosInstance";
import APP_URL_NOTES from "../../constants/notes";
import { getCurrentUserName, getCurrentUserId } from "../../helpers/currentUser";

const TOKEN = localStorage.getItem("token");

class ApiNotes {
  // LIST NOTES
  async getNotes(data, idNvlEdu, token2) {
    let dataSend = { ...data, idnivel_educativo: idNvlEdu };
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LIST_NOTES,
        dataSend,
        {
          headers: { Authorization: `Bearer ${token2}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // LIST DEFINITIVAS DE TODAS LAS ASIGNATURAS DE UN CURSO (1 sola petición)
  async getDefinitivasCurso(data, token2) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LIST_DEFINITIVAS_CURSO,
        data,
        {
          headers: { Authorization: `Bearer ${token2}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // CREATE NOTES
  async createNotes(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.CREATE_NOTES,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      // Sin error.response = no hubo respuesta HTTP del servidor (sin
      // internet, timeout, servidor caído) — distinto de un rechazo real
      // del backend (validación, 4xx/5xx con body).
      if (!error.response) {
        return {
          success: false,
          isNetworkError: true,
          error: { message: "Sin conexión a internet." },
        };
      }
      return { success: false, error: error.response.data };
    }
  }

  // DOWNLOAD FORM
  async downloadForm(data, nameExcel) {
    try {
      const options = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        responseType: "blob",
      };

      const response = await AxiosInstance.post(
        APP_URL_NOTES.DOWNLOAD_FORM,
        data,
        options
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${nameExcel}.xlsx`);
      document.body.appendChild(link);
      link.click();

      return { success: true, response: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data ?? { message: error.message },
      };
    }
  }

  // UPLOAD FORM ACTIVITY
  async uploadForm(data) {
    let formData = new FormData();
    formData.append("idanio_lectivo", data.idanio_lectivo);
    formData.append("idgrados_grupos", data.idgrados_grupos);
    formData.append("idgrados_asignatura", data.idgrados_asignatura);
    formData.append("idnivel_educativo", data.idnivel_educativo);
    formData.append("idperiodo", data.idperiodo);
    formData.append("upload", data.upload);
    const response = await AxiosInstance.post(
      APP_URL_NOTES.UPLOAD_FORM,
      formData,
      {
        headers: { Authorization: `Bearer ${TOKEN}` },
      }
    );
    return response;
  }

  // LIST OBSERVATIONS
  async getObservations(idgrados_asignatura, idperiodo, token2) {
    let data = { idgrados_asignatura, idperiodo };
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LIST_OBSERVATIONS,
        data,
        {
          headers: { Authorization: `Bearer ${token2}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // CREATE OBSERVATIONS
  async createObservations(
    idEstlicense,
    idDegreeGroups,
    idPeriod,
    observation
  ) {
    let data = {
      idestumatricula: idEstlicense,
      idgrados_asignatura: idDegreeGroups,
      idperiodo: idPeriod,
      observacion: observation,
    };
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.CREATE_OBSERVATIONS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // LIST RECUPERATIONS
  async getRecuperations(data, idNvlEdu, token2) {
    let dataSend = { ...data, idnivel_educativo: idNvlEdu };
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LIST_RECUPERATIONS,
        dataSend,
        {
          headers: { Authorization: `Bearer ${token2}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // CREATE NOTES
  async createNotesRecovery(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.CREATE_RECUPERATIONS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // LIST OBSERVATIONS RECOVERY
  async getObservationsRecovery(idgrados_asignatura, idperiodo, token2) {
    let data = { idgrados_asignatura, idperiodo, session: {} };
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LIST_OBSERVATIONS_RECOVERY,
        data,
        {
          headers: { Authorization: `Bearer ${token2}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // CREATE OBSERVATIONS RECOVERY
  async createObservationsRecovery(idestumatricula, idgrados_asignatura, idperiodo, observacion) {
    let data = { idestumatricula, idgrados_asignatura, idperiodo, observacion };
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.CREATE_OBSERVATIONS_RECOVERY,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // HISTORY NOTES
  async historyNotes(idmatricula, idactividad) {
    let data = { idmatricula, idactividad };
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.HISTORY_NOTES,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }
  //Promedio Total
  async getPromedioTotal(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.PROMEDIO_TOTAL,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getPromedioTotalTeacher(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.PROMEDIO_TOTAL_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  //Promedio Total
  async getPromedioExtremo(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.GRADO_PROMEDIO_EXTREMO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getClasesHoy(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.CLASES_HOY,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getActividadesProximas(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.ACTIVIDADES_PROXIMAS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getDistribucionPromedios(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.DISTRIBUCION_PROMEDIOS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getResumenEvaluacionDocente(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.RESUMEN_EVALUACION_DOCENTE,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getResumenEvaluacion(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.RESUMEN_EVALUACION,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getPromedioPorGrado(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.PROMEDIO_POR_GRADO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getPromedioPorPeriodo(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.PROMEDIO_POR_PERIODO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getResumenAcademico(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.RESUMEN_ACADEMICO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  //Promedio Total Docente
  async getPromedioExtremoTeacher(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.GRADO_PROMEDIO_EXTREMO_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  //Promedio Areas
  async getPromedioExtremoAreas(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.AREAS_PROMEDIO_EXTREMO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getPromedioExtremoAreasDocente(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.AREAS_PROMEDIO_EXTREMO_TEACHER,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  //Promedio x Gnero
  async getPromedioGeneros(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.PROMEDIO_GENEROS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getPromedioGenerosDocente(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.PROMEDIO_GENEROS_DOCENTE,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  //obtener el top 3 de estudiantes > PROMEDIO
  async getTopEstudiantes(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.TOP_ESTUDIANTES,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  //obtener el top 3 de estudiantes-docente > PROMEDIO
  async getTopEstudiantesDocente(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.TOP_ESTUDIANTES_DOCENTE,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  //obtener mejor estudiante promedio de ambas jornadas
  async getTopEstudiantePromedio(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.OBTENER_PROMEDIOS_GENERAL_ESTUDIANTE,
        data,
        {
          headers: {
            Authorization: `Bearer ${TOKEN}`
          }
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // Obtener el top 3 de docentes > PROMEDIO
  async getTopDocentes(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.TOP_DOCENTES,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // Obtener el top 10 de estudiantes con asignaturas perdidas
  async getTopEstudiantesPerdidas(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.TOP_ESTUDIANTES_PERDIDAS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }
  async getTopEstudiantesPerdidasDocente(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.TOP_ESTUDIANTES_PERDIDAS_DOCENTE,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getPromediosPorDias(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.TOP_PROMEDIOS_POR_DIAS,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  async getPromediosPorDiasDocente(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.TOP_PROMEDIOS_POR_DIAS_DOCENTE,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // GENERAR CERTIFICADO NOTAS GRL
  async generarCertificadoNotasGRL(data, nombre) {
    try {
      const headers = {
        Authorization: `Bearer ${TOKEN}`,
      };

      const response = await AxiosInstance.post(
        APP_URL_NOTES.CERTIFICADO_NOTAS_GRL,
        data,
        { responseType: "blob", headers }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const report = document.createElement("a");
      report.href = url;
      report.download = `certificado_notas_${nombre}.pdf`;

      // report.style.display = "none";

      document.body.appendChild(report);
      report.click();

      document.body.removeChild(report);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error to download" };
    }
  }

  // GET CERTIFICADO NOTAS GRL DATA — para preview (retorna blob sin descargar)
  async getCertificadoNotasGRLData(data) {
    try {
      const headers = { Authorization: `Bearer ${TOKEN}` };
      const response = await AxiosInstance.post(
        APP_URL_NOTES.CERTIFICADO_NOTAS_GRL,
        data,
        { responseType: "blob", headers }
      );
      return { success: true, data: response.data };
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error al obtener preview" };
    }
  }

  // GENERAR CERTIFICADO NOTAS VDP
  async generarCertificadoNotasVDP(data, nombre) {
    try {
      const headers = {
        Authorization: `Bearer ${TOKEN}`,
      };

      const response = await AxiosInstance.post(
        APP_URL_NOTES.CERTIFICADO_NOTAS_VDP,
        data,
        { responseType: "blob", headers }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const report = document.createElement("a");
      report.href = url;
      report.download = `certificado_estudio_${nombre}.pdf`;

      // report.style.display = "none";

      document.body.appendChild(report);
      report.click();

      document.body.removeChild(report);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error to download" };
    }
  }

  // GET CERTIFICADO NOTAS VDP DATA — para preview (retorna blob sin descargar)
  async getCertificadoNotasVDPData(data) {
    try {
      const headers = { Authorization: `Bearer ${TOKEN}` };
      const response = await AxiosInstance.post(
        APP_URL_NOTES.CERTIFICADO_NOTAS_VDP,
        data,
        { responseType: "blob", headers }
      );
      return { success: true, data: response.data };
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error al obtener preview" };
    }
  }

  // GENERAR CERTIFICADO BUENA CONDUCTA
  async generarCertificadoBuenaConducta(data, nombre) {
    try {
      const headers = {
        Authorization: `Bearer ${TOKEN}`,
      };

      const response = await AxiosInstance.post(
        APP_URL_NOTES.CERTIFICADO_NOTAS_BUECOND,
        data,
        { responseType: "blob", headers }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const report = document.createElement("a");
      report.href = url;
      report.download = `certificado_buena_conducta_${nombre}.pdf`;

      // report.style.display = "none";

      document.body.appendChild(report);
      report.click();

      document.body.removeChild(report);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error to download" };
    }
  }

  // GET CERTIFICADO BUENA CONDUCTA DATA — para preview (retorna blob sin descargar)
  async getCertificadoBuenaConductaData(data) {
    try {
      const headers = { Authorization: `Bearer ${TOKEN}` };
      const response = await AxiosInstance.post(
        APP_URL_NOTES.CERTIFICADO_NOTAS_BUECOND,
        data,
        { responseType: "blob", headers }
      );
      return { success: true, data: response.data };
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error al obtener preview" };
    }
  }

  // API para listar estudiantes de un grado grupo
  async listarEstudiantes(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LISTAR_ESTUDIANTES_GRADOGRUPO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // LIST NOTES ACTIVITY CENTRO ACADEMICO
  async getNotesActivityCentroAcademico(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LIST_NOTES_ACTIVITY_CENTRO_ACADEMICO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }
  // LIST NOTES ACTIVITY FORO CENTRO ACADEMICO
  async getNotesActForoCentroAcademico(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LIST_NOTES_ACTFORO_CENTRO_ACADEMICO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }
  // LIST ACTIVITYS FOROS CENTRO ACADEMICO
  async getActsForosCentroAcademico(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LIST_ACTSFOROS_CENTRO_ACADEMICO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        }
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // GENERAR PDF PLANILLA MENSUAL NOTAS
  async generarPlanillaMensualNotas(data) {
    try {
      const headers = {
        Authorization: `Bearer ${TOKEN}`,
      };

      const response = await AxiosInstance.post(
        APP_URL_NOTES.PLANILLA_MENSUAL_NOTAS,
        data,
        { responseType: "blob", headers }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const report = document.createElement("a");
      report.href = url;
      report.download = `planilla_mensual_notas_${data.grado_grupo}_${data.asignatura}.pdf`;

      // report.style.display = "none";

      document.body.appendChild(report);
      report.click();

      document.body.removeChild(report);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("error =>", error);
      return { success: false, error: "Error to download" };
    }
  }

  async generarPlanillaMensualNotasMasiva(data) {
    try {
      const headers = {
        Authorization: `Bearer ${TOKEN}`,
      };

      const response = await AxiosInstance.post(
        APP_URL_NOTES.PLANILLA_MENSUAL_NOTAS_MASIVAS,
        data,
        { responseType: "blob", headers }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const report = document.createElement("a");
      report.href = url;
      report.download = `planilla_mensual_masiva_${data.anio}_${data.mes}.pdf`;

      document.body.appendChild(report);
      report.click();

      document.body.removeChild(report);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("Error =>", error);
      return { success: false, error: "Error to download" };
    }
  }

  async generarPlanillaMensualNotasMasivaTotal(data) {
    try {
      const headers = { Authorization: `Bearer ${TOKEN}` };

      // 1. Lanzar generación — respuesta inmediata con jobId
      const { data: jobData } = await AxiosInstance.post(
        APP_URL_NOTES.PLANILLA_MENSUAL_NOTAS_MASIVAS_TOTAL,
        { ...data, nombre_usuario: getCurrentUserName(), idusuario: getCurrentUserId() },
        { headers },
      );

      if (!jobData.success || !jobData.jobId) {
        return { success: false, error: "No se recibió jobId del servidor" };
      }

      // 2. Polling hasta que el job esté listo
      const JOB_URL = `${APP_URL_NOTES.GET_PLANILLA_NOTAS_JOB}${jobData.jobId}`;
      let buffer = null;
      for (let intento = 0; intento < 200; intento++) {
        await new Promise((resolve) => setTimeout(resolve, 3000));

        const resp = await AxiosInstance.get(JOB_URL, {
          headers,
          responseType: "arraybuffer",
          validateStatus: (s) => s < 600,
        });

        const contentType = resp.headers["content-type"] || "";

        if (resp.status >= 400) {
          const text = new TextDecoder().decode(resp.data);
          let mensaje = "Error en el servidor";
          try { const json = JSON.parse(text); mensaje = json.mensaje || json.message || mensaje; } catch (_) {}
          throw new Error(mensaje);
        }

        if (contentType.includes("application/pdf")) {
          buffer = resp.data;
          break;
        }

        if (contentType.includes("application/json")) {
          const text = new TextDecoder().decode(resp.data);
          const json = JSON.parse(text);
          if (json.status === "error") throw new Error(json.mensaje || "Error en generación");
          continue;
        }
      }

      if (!buffer) throw new Error("Tiempo de espera agotado para la generación de planillas.");

      // 3. Descargar
      const url = window.URL.createObjectURL(new Blob([buffer], { type: "application/pdf" }));
      const report = document.createElement("a");
      report.href = url;
      report.download = `planilla_mensual_masiva_total.pdf`;
      document.body.appendChild(report);
      report.click();
      document.body.removeChild(report);
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      console.log("Error =>", error);
      return { success: false, error: error.message || "Error to download" };
    }
  }

  // LISTAR PROMEDIOS POR GRADOGRUPO Y PERIODO
  async listarPromediosGradogrupoPeriodo(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.OBTENER_PROMEDIOS_GRADOGRUPO_PERIODO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }
  
    // HISTORIAL DE PLANILLAS DE NOTAS MASIVAS
    async listarHistorialPlanillasNotas(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.HISTORIAL_PLANILLA_NOTAS_MASIVA,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async descargarHistorialPlanillaNotas(id, nombreArchivo) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.DESCARGAR_HISTORIAL_PLANILLA_NOTAS_MASIVA,
        { id },
        { responseType: "blob", headers: { Authorization: `Bearer ${TOKEN}` } },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const report = document.createElement("a");
      report.href = url;
      report.download = nombreArchivo || "planilla_notas_masiva.pdf";
      document.body.appendChild(report);
      report.click();
      document.body.removeChild(report);
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      return { success: false, error: "Error al descargar el archivo" };
    }
  }

  async eliminarHistorialPlanillaNotas(id) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.ELIMINAR_HISTORIAL_PLANILLA_NOTAS_MASIVA,
        { id },
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

    async obtenerOpcionesPlanillaMensualMasiva(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.OPCIONES_PLANILLA_MENSUAL_MASIVA,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      console.log("Error =>", error);
      return { success: false, error: "Error to get options" };
    }
  }

  // LISTAR Observaciones GRADOGRUPO Y PERIODO
  async listarObservacionesPorGradoGrupoYPeriodo(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.OBTENER_OBSERVACIONES_GRADOGRUPO_PERIODO,
        data,
        {
          headers: { Authorization: `Bearer ${TOKEN}` },
        },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response.data };
    }
  }

  // GUARDAR CONVIVENCIA GENERAL DOCENTE
  async guardarConvivenciaDocente(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.GUARDAR_CONVIVENCIA_DOCENTE,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  // LISTAR CONVIVENCIA GENERAL DOCENTE
  async listarConvivenciaDocente(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LISTAR_CONVIVENCIA_DOCENTE,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  // GUARDAR CONVIVENCIA DOCENTE CON DETALLE POR COLUMNA
  // payload esperado (convivencia es por CURSO, no por asignatura):
  // {
  //   idanio_lectivo, idgrados_grupos, idperiodo,
  //   columnas: [{ id, label, pct }],
  //   estudiantes: [
  //     { idestumatricula, nota, notas_columnas: [{ idcolumna, nota }] }
  //   ]
  // }
  async guardarConvivenciaDocenteDetalle(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.GUARDAR_CONVIVENCIA_DOCENTE_DETALLE,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  // LISTAR CONVIVENCIA DOCENTE CON DETALLE POR COLUMNA
  // respuesta esperada:
  // { data: { columnas: [...], estudiantes: [{ idestumatricula, nota, notas_columnas: [...] }] } }
  async listarConvivenciaDocenteDetalle(data) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.LISTAR_CONVIVENCIA_DOCENTE_DETALLE,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  // MODO DE CÁLCULO: competencias sin actividades/notas.
  // false (default) = solo se ponderan las competencias con notas.
  // true = se ponderan TODAS las competencias configuradas (las vacías
  // cuentan como 0).
  async getModoCompetenciasVacias() {
    try {
      const response = await AxiosInstance.get(
        APP_URL_NOTES.GET_MODO_COMPETENCIAS_VACIAS,
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async guardarModoCompetenciasVacias(incluirCompetenciasVacias) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.SAVE_MODO_COMPETENCIAS_VACIAS,
        { incluir_competencias_vacias: incluirCompetenciasVacias },
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async getContarCeroComoVacia() {
    try {
      const response = await AxiosInstance.get(
        APP_URL_NOTES.GET_CONTAR_CERO_COMO_VACIA,
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }

  async guardarContarCeroComoVacia(contarCeroComoVacia) {
    try {
      const response = await AxiosInstance.post(
        APP_URL_NOTES.SAVE_CONTAR_CERO_COMO_VACIA,
        { contar_cero_como_vacia: contarCeroComoVacia },
        { headers: { Authorization: `Bearer ${TOKEN}` } },
      );
      return { success: true, response: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data };
    }
  }
}

export default new ApiNotes();
